function isPlainObject(obj) {
    return (
        Object.prototype.toString.call(obj) === "[object Object]" &&
        !Array.isArray(obj)
    );
}

/**
 * @param {ayn} obj 检测对象
 * @description 检测手机号码
 */
let isPhone = (obj) => {
    let reg = /^[1][3-9][0-9]{9}$/;
    return reg.test(obj);
};

/**
 * @param {any} obj 检测对象
 * @description 检测是否空数据
 */
let isEmpty = (obj) => {
    if (obj === "") return true;
    if (typeof obj === "undefined") return true;
    if (obj === undefined) return true;
    if (obj === null) return true;
    if (Array.isArray(obj) || typeof obj === "string") return obj.length === 0;
    if(isPlainObject(obj)) return Object.keys(obj).length === 0;
    for (var key in obj) {
        return false;
    }
    return false;
};

/**
 * @description 验证是否是邮箱
 */
let isMail = (obj) => {
    let reg = /^[^@].*@[a-zA-Z0-9\-\_]+(\.[a-zA-Z]{2,14})*\.([a-zA-Z]{2,14})$/;
    return reg.test(obj);
};

/**
 * @param {any} obj 检测对象
 * @description 是否是正整数
 */
let isPositiveNumber = (obj) => {
    let reg = /^\d+$/;
    return reg.test(obj);
};

/**
 * @description 是否是短信验证码
 */
let isSmsCode = (any) => {
    let reg = /\d{4}/;
    return reg.test(any);
};

/**
 * @description 是否是空字符串
 */
let isEmptyString = (any) => {
    return any === "";
};

/**
 * @description 是否是税务号
 */
let isTaxNumber = (obj) => {
    let reg = /^[a-zA-Z0-9]{15,30}$/;
    return reg.test(obj);
};

let isFloat = (any) => {
    let reg = /^\d+\.\d{1,2}$/;
    return reg.test(any);
};
/**
 *
 *
 * @param {any} obj 检测数据
 * @returns {boolean}
 * @description 是否是银行卡号
 */
let isBankNumber = (obj) => {
    let reg = /^\d[\d\s\-]+\d$/;
    return reg.test(obj);
};

/**
 * @description 是否是钱包密码
 */
let isWalletPassword = (password) => {
    let reg = /\d{6}/;
    return reg.test(password);
};

/**
 *
 *
 * @export
 * @param {*} code
 * @description 是否是自定义编码
 */
let isEncode = (code) => {
    let reg = /[_*^&@!#$¥()<>\s]+/g;
    return !reg.test(code);
};

export {
    isPhone,
    isEmpty,
    isPositiveNumber,
    isMail,
    isSmsCode,
    isEmptyString,
    isTaxNumber,
    isFloat,
    isBankNumber,
    isWalletPassword,
    isEncode,
    isPlainObject
};
